export const getAsBase64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = function (event) {
      if (!event.target) {
        reject(new Error('Failed to read the file'));
        return;
      }
      const result = event.target.result as string;
      const base64Content = result.split(',')[1]; // Extract base64 content after the comma
      resolve(base64Content);
    };
    fileReader.onerror = function (error) {
      reject(error);
    };
    if (file) {
      fileReader.readAsDataURL(file);
    } else {
      reject(new Error('No file provided'));
    }
  });
};
